<button type="button" class="modal-open-button" [attr.aria-label]="intl.openButtonLabel" (click)="open()">
  <div class="language-field">{{ activeLanguage?.code }}</div>
  <img class="region-flag" [src]="'assets/flags/' + activeRegion?.code?.toLowerCase() + '.svg'" [attr.alt]="activeRegion?.name">
</button>
<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<dialog #dialog (click)="close()">
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <form method="dialog" kb-card [formGroup]="form" (ngSubmit)="onSubmit()" (click)="$event.stopPropagation()">
    <h3 class="dialog-heading" slot="title" kb-heading type="bar">
      {{intl.modalHeading}}
      <button type="button" (click)="close()" kb-icon icon-uppercase icon-center [icon]="iconClose" [attr.aria-label]="intl.closeButtonLabel"></button>
    </h3>
    <div slot="content" kb-layout="grid">

      <kb-select kb-grid-item-columns="12" formControlName="region" [showRequired]="false" [valueComparator]="regionComparator">
        <kb-label>{{intl.regionSelectLabel}}</kb-label>
        @for (region of regions; track region.code) {
          <kb-select-option [value]="region">
            <ng-template>{{region.name}}</ng-template>
          </kb-select-option>
        }
      </kb-select>

      <kb-select kb-grid-item-columns="12" formControlName="language" [showRequired]="false" [valueComparator]="languageComparator">
        <kb-label>{{intl.languageSelectLabel}}</kb-label>
        <kb-error>{{intl.languageIsRequiredError}}</kb-error>
        <kb-select-option><ng-template>{{intl.noSelectedLanguageOptionLabel}}</ng-template></kb-select-option>
        @for (language of selectedRegion?.languages; track language.code) {
          <kb-select-option [value]="language">
            <ng-template>{{language.nativeName}}</ng-template>
          </kb-select-option>
        }
      </kb-select>

      <div kb-grid-item-columns="12">
        <button kb-button type="submit">{{intl.submitButtonLabel}}</button>
      </div>

    </div>
  </form>
</dialog>
